import { createSlice } from "@reduxjs/toolkit";
import { doucmentAnalyticAction, doucmentDashboardAction, getDocumentProductsAction } from "../asyncActions/documentActions";
import { warehouseDocumentAction } from "../asyncActions/warhouseActions";


const documentProductsSLice = createSlice({
    name: 'documentProductsSLice',
    initialState: {
        document: {},
        warehouseDocument: {},
        documentProducts: [],
        warehouseDocumentProducts: [],
        dashboardProducts: [],
        analyticProduct: [],
        dataLoad: false,
        error: null
    },
    reducers: {
        setError(state, action){
            state.error = action.payload
        },
        clearData(state){
            state.documentProducts = []
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDocumentProductsAction.fulfilled, (state, action) => {
                state.document = action.payload.document
                state.documentProducts = action.payload.product_documents.sort((a,b) => a.product_branch.category_id - b.product_branch.category_id)
                state.dataLoad = false
                state.error = null
            })
            .addCase(getDocumentProductsAction.pending, (state) => {
                state.dataLoad = true
                state.documentProducts = []
                state.error = null
            })
            .addCase(getDocumentProductsAction.rejected, (state, action) => {
                state.dataLoad = false
                state.error = action.payload?.detail && 'some problem'
            })

            .addCase(doucmentDashboardAction.fulfilled, (state, action) => {
                state.dashboardProducts = [...action.payload].sort((a,b) => a.category_name.localeCompare(b.category_name))
                state.dataLoad = false
                state.error = null
            })
            .addCase(doucmentDashboardAction.pending, (state) => {
                state.dataLoad = true
                state.error = null
            })
            .addCase(doucmentDashboardAction.rejected, (state, action) => {
                state.dataLoad = false
                state.error = action.payload?.detail && 'some problem'
            })
            .addCase(doucmentAnalyticAction.fulfilled, (state, action) => {
                state.analyticProduct = action.payload
                state.dataLoad = false
                state.error = null
            })
            .addCase(doucmentAnalyticAction.pending, (state) => {
                state.dataLoad = true
                state.error = null
            })
            .addCase(doucmentAnalyticAction.rejected, (state, action) => {
                state.dataLoad = false
                state.error = action.payload?.detail && 'some problem'
            })

            .addCase(warehouseDocumentAction.fulfilled, (state, action) => {
                const {
                    document,
                    products 
                } = action.payload
                state.warehouseDocument = document
                state.warehouseDocumentProducts = products
                state.dataLoad = false
                state.error = null
            })
            .addCase(warehouseDocumentAction.pending, (state) => {
                state.dataLoad = true
                state.error = null
            })
            .addCase(warehouseDocumentAction.rejected, (state, action) => {
                state.dataLoad = false
                state.error = action.payload?.detail && 'some problem'
            })
    }
})



export default documentProductsSLice.reducer

export const getDocumentProductData = (state) => state.documentProducts

export const {
    setError,
    clearData
} =    documentProductsSLice.actions


// branchProductsAction